export default () => {
    return {
        delay: false,
        duration: 0.4,
        ease: 'expo.out',
        opacity: 0,
        scrollSettings: false,
        stagger: 0.008,
        yPercent: 101,

        mounted(delay = this.$store.animationDelay, scrollTrigger = true) {
            if (scrollTrigger) {
                this.scrollSettings = {
                    start: 'top 85%',
                    trigger: this.$refs.wrapper,
                    toggleActions: 'play none play none'
                };
            }

            this.delay = delay;

            this.animate();
        },

        animate() {
            const split = new SplitText(this.$refs.wrapper, {
                type: 'words, lines',
                linesClass: '-mt-2 py-1 pr-1 overflow-hidden'
            });

            gsap.from(split.words, {
                opacity: this.opacity,
                yPercent: this.yPercent,
                duration: this.duration,
                stagger: this.stagger,
                delay: this.delay,
                ease: this.ease,
                scrollTrigger: this.scrollSettings
            });
        }
    };
};
